import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { config } from '../config/buyout';
import * as messages from '../locale/buyout';

Vue.use(VueI18n);

const dateTimeFormats = {
	cs: {
		short: {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		}
	},
	sk: {
		short: {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		}
	}
}

const numberFormats = {
	cs: {
    currency: {
      style: 'currency', currency: 'CZK', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    integer: {
      style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
  },
	sk: {
    currency: {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    integer: {
      style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
  },
	en: {
    currency: {
      style: 'currency', currency: 'CZK', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
    integer: {
      style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0,
    },
  },
}

const pluralizationRules = {
  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index to select plural word by
   */
  cs: function (choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    if (choice === 0) {
      return 0;
    } else if (choice === 1) {
      return (choicesLength > 1)? 1 : 0;
    }

    if (choice >= 2 && choice <= 4) {
      return (choicesLength >= 3)? 2 : 1;
    }

    if (choice > 4) {
      return (choicesLength >= 4)? 3 : 2;
    }

    return (choicesLength < 4) ? 2 : 3;
  }
}


export default new VueI18n({
	locale: config.language, // set locale
	messages: { ...messages }, // set locale messages
	dateTimeFormats,
	pluralizationRules,
	numberFormats,
});
